module.exports = __webpack_public_path__ + "static/media/test3_3.33b1c352.png";